export default [
  {
    path: '/calls',
    name: 'calls',
    component: () => import('@/views/calls/Calls'),
    meta: {
      protected: true,
      pageTitle: 'Calls',
    },
  },
  {
    path: '/calls/requested',
    name: 'requested-calls',
    component: () => import('@/views/calls/callLists/RequestedCalls.vue'),
    meta: {
      protected: true,
      pageTitle: 'Call List',
    },
  },
  {
    path: '/calls/awaiting-confirmation',
    name: 'awaiting-calls',
    component: () => import('@/views/calls/callLists/AwaitingCalls.vue'),
    meta: {
      protected: true,
      pageTitle: 'Call List',
    },
  },
  {
    path: '/calls/approved',
    name: 'approved-calls',
    component: () => import('@/views/calls/callLists/ApprovedCalls.vue'),
    meta: {
      protected: true,
      pageTitle: 'Call List',
    },
  },
  {
    path: '/calls/cancelled',
    name: 'cancelled-calls',
    component: () => import('@/views/calls/callLists/CancelledCalls.vue'),
    meta: {
      protected: true,
      pageTitle: 'Call List',
    },
  },
  {
    path: '/calls/completed',
    name: 'completed-calls',
    component: () => import('@/views/calls/callLists/CompletedCalls.vue'),
    meta: {
      protected: true,
      pageTitle: 'Call List',
    },
  },
  {
    path: '/calls/approved/print',
    name: 'approved-calls-print',
    component: () => import('@/views/calls/printCalls/PrintCalls.vue'),
    meta: {
      protected: true,
      pageTitle: 'Calls Print',
    },
  },
  {
    path: '/calls/:id/details',
    name: 'call-details',
    component: () => import('@/views/calls/callDetails/CallDetails.vue'),
    meta: {
      protected: true,
      pageTitle: 'Call Details',
    },
  },
]
